import { AfterViewChecked, Component, Input, OnInit } from '@angular/core';
import { RaceDocument } from 'src/app/models/race_document';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-partipian-document',
  templateUrl: './partipian-document.component.html',
  styleUrls: ['./partipian-document.component.scss'],
})
export class PartipianDocumentComponent implements OnInit, AfterViewChecked {
  @Input() doc!: RaceDocument;
  blockEdit = false;

  constructor(public appSettings: SettingsService) {}
  ngAfterViewChecked(): void {
    this.autoResize();
  }

  ngOnInit() {
    // разрешаем всегда редактировать
    // if (this.doc.valid === true || this.doc.valid === false) {
    //   this.blockEdit = true;
    // } else {
    //   this.blockEdit = false
    // }
  }

  setValid(doc, value) {
    doc.valid = value;
    if (doc.valid) {
      doc.reason = undefined;
    }
  }

  autoResize(): void {
    const textarea = document.querySelector('textarea') as HTMLTextAreaElement;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }
}
